'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const fixHeight = require('./../../../services/fixHeight');
const zone = require('./../../../services/structure/zone');
const translator = require('./../../../core/translator');
const mediator = require('./../../../core/mediator');
const container = require('./../../../core/container');
const pageRepository = require('./../repository/page');
const LangRepository = require('./../../../bundles/user/repository/LangRepository');
const FormBuilder = require('./../../../services/form');
const PopinManager = require('./../../../services/popin');
const Loader = require('./../../../services/loader');
const Notifier = require('./../../../services/notifier');
const flashMessage = require('./../../../services/flashMessage');
const Help = require('./../../../services/help');
const helper = require('./../../../services/helper');

const HEADER_PAGE_URL = 'X-Page-URL';

let deletePopin;
let pageLabel;
let langs = [];

let getLangs = function() {
  let dfd = jQuery.Deferred();

  if (langs.length) {
    dfd.resolve(langs);
  } else {
    LangRepository.findAll('page_parameters').done(function(data) {
      langs = data;
      dfd.resolve(langs);
    });
  }

  return dfd.promise();
};

let isLangsActived = function(data) {
  return data.filter((lang) => lang.is_active).length > 1;
};

const onValidate = function(data, form) {
  if (data.title && helper.isValidTitle(data.title)) {
    form.addError('title', translator.translate('error_title_page'));
  }
};

const onSubmit = function(page, form) {
  let data = {};
  let dfd = jQuery.Deferred();

  _.each(page, function(value, key) {
    if (form.page[key] !== value) {
      if (-1 !== key.indexOf('seo_')) {
        data.seo = data.seo || {};
        data.seo[key.replace('seo_', '')] = value;
      } else {
        data[key] = value;
      }
    }
  });

  pageRepository.save(data, {'uid': container.get('page.uid')}).done(function(data, response) {
    Notifier.success(translator.translate('parameters_saved'));
    zone.hidePanels();

    window.location.href = response.getHeader(HEADER_PAGE_URL) || response.getHeader(HEADER_PAGE_URL.toLowerCase());

    dfd.resolve();
  }).fail(function(response, request) {
    let rawData = response.getRawData();
    let error = translator.translate('error');

    if (rawData) {
      rawData = JSON.parse(rawData);
      if (rawData.reason) {
        error = rawData.reason;
      }
    }

    Notifier.warning(error);
    dfd.reject(response, request);
  });
};

const onDelete = function() {
  pageRepository.delete(container.get('page.uid')).done(function() {
    flashMessage.add(translator.translate('page_delete_confirmation'));
    window.location.replace('/');
  }).fail(function() {
    Notifier.warning(translator.translate('error'));
  });
};

const deleteConfirm = function() {
  if (deletePopin && deletePopin.invoke('isOpen')) {
    return;
  }

  deletePopin = PopinManager.createPopin({
    'title': translator.translate('page_delete_modal_title'),
    'minHeight': 50,
    'buttons': [
      {
        class: 'popin popin-cancel',
        text: translator.translate('discard'),
        click: function() {
          deletePopin.hide();
        },
      },
      {
        class: 'popin popin-ok',
        text: translator.translate('delete'),
        click: function() {
          deletePopin.hide();
          onDelete();
        },
      },
    ],
  });

  container.set('prevent-hide-toolbar', true);
  container.set('prevent-hide-overlay', true);
  deletePopin.on('close', function() {
    setTimeout(function() {
      container.set('prevent-hide-toolbar', false);
      container.set('prevent-hide-overlay', false);
    }, 100);
  });

  deletePopin.setContent('<p>' + translator.translate('page_delete_modal_message') + '</p>' + pageLabel);
  deletePopin.display();
};

const onAssociatedPageLinkClick = function(e, page) {
  e.preventDefault();

  let requesting = false;
  let $container = jQuery('<div></div>');
  let currentPageUid = container.get('page.uid');

  let $panel = zone.addLayer(translator.translate('manage_associated_pages_panel_title'), $container);

  $container.append(`<p class="small">${translator.translate('page_equivalent_panel_description')}</p><p class="small">${translator.translate('page_equivalent_panel_indication')}</p>`);
  $container.append('<div class="form-wrapper" />');

  let buildForm = () => {
    Loader.start($panel);

    pageRepository.getAssociatedPages(currentPageUid).done((associatedPages) => {
      let form = FormBuilder.getForm({
        elements: {
          'page_language': {
            'type': 'text',
            'label': translator.translate('page_language'),
            'value': translator.translate(`new_page_${page.lang}`),
            'disabled': true,
          },
          'title': {
            'type': 'text',
            'label': translator.translate('page_parameters_form_title'),
            'value': page.title,
            'disabled': true,
          },
          'pages': {
            'type': 'searchList',
            'label': translator.translate('page_equivalent_form_label'),
            'url_request': `/api/multilang/associated-pages/custom-search-page/${currentPageUid}`,
            'valueName': 'id',
            'labelName': 'title',
            'itemRenderType': 'flag',
            'addItemOnSelect': false,
            'minLength': 2,
            'onListChange': function(length) {
              $container.find('.no-associated-pages')[!length ? 'removeClass' : 'addClass']('d-none');
            },
            'onSelect': function(item) {
              requesting = true;
              pageRepository.associatePage(currentPageUid, item.value).done(() => {
                requesting = false;
                buildForm();
              });
            },
            'onRemoveItem': function(item) {
              requesting = true;
              pageRepository.removeAssociatePage(item.item.extra.id).done(() => {
                requesting = false;
              });
            },
            'onAddItem': function(data) {
              data.extra.flag = data.extra.lang;
            },
            'onItemSearch': function(item) {
              item.label = (item.extra.lang ? `${item.extra.lang.toUpperCase()} - ` : '') + `${item.label}`;
            },
            'value': associatedPages,
          },
        },
        form: {
          'submit_class': 'd-none',
        },
      });

      $container.find('.form-wrapper').html(form.render());
      $container.find('.form-wrapper').append(`<p class="no-associated-pages small">${translator.translate('no_associated_pages')}</p>`);

      if (associatedPages.length) {
        $container.find('.no-associated-pages').addClass('d-none');
      }

      Loader.stop($panel);
    });
  };

  buildForm();

  let $finishBtn = jQuery(`<button type="submit" class="btn btn-primary btn-block">${translator.translate('finish')}</button>`);
  $finishBtn.on('click', function() {
    if (!requesting) {
      window.location.reload();
    }
  });

  zone.setFooter($panel, $finishBtn);
};

module.exports.init = function() {
  let dfd = jQuery.Deferred();
  let $container = jQuery('<div></div>');
  let form;
  let $panel = zone.setSmallPanel(translator.translate('page_parameters'), $container, true, {
    'extraTitle': Help.createLink('page_parameters'),
  });

  Loader.start($panel);

  getLangs().done(function(langs) {
    pageRepository.find(container.get('page.uid')).done(function(page) {
      pageRepository.getCategories().done((pageCategories) => {
        let searchEngine = Boolean(page.search_engine_activated);
        let $buttons = jQuery('<div />');

        if (container.get('isAllowedTo')('EDIT_PAGE') || container.get('isAllowedTo')('PUBLISH_PAGE')) {
          let config = {
            form: {
              'submit_class': 'd-none',
            },
          };

          let type = translator.translate(`page_type_${page.type}`) === `page_type_${page.type}` ? `new_page_${page.type}` : `page_type_${page.type}`;

          config.elements = {
            'page_type': {
              'type': 'text',
              'label': translator.translate('page_type'),
              'value': translator.translate(type),
              'disabled': true,
              'ignoreOnSubmit': true,
            },
            'category': {
              'type': 'select',
              'label': translator.translate('group_management_page_categories'),
              'options': function() {
                return pageCategories.reduce((options, category) => {
                    options[category] = translator.translate(`page_category_${category}`);
                    return options;
                  },
                  {
                    none: translator.translate('none_page_categories'),
                  },
                );
              }(),
              'value': page.category || 'none',
            },
            'page_language': {
              'type': 'text',
              'label': translator.translate('page_language'),
              'value': translator.translate(`new_page_${page.lang}`),
              'disabled': true,
              'ignoreOnSubmit': true,
              'wrap_class': isLangsActived(langs) ? '' : 'd-none',
            },
            'title': {
              'type': 'text',
              'label': translator.translate('page_parameters_form_title'),
              'value': page.title,
            },
            'is_online': {
              'type': 'switch',
              'label': translator.translate('page_parameters_form_online'),
              'value': page.is_online,
            },
            'published_at': {
              'type': 'datetimepicker',
              'enable_time': true,
              'label': translator.translate('page_parameters_form_publication_date'),
              'value': page.published_at || null,
              'wrap_class': 'input-group cloud-group cloud-datetimepicker',
              'label_class': 'cloud-label w-100',
              'element_class': 'cloud-control form-control',
            },
            'tags': {
              'type': 'selectTag',
              'label': translator.translate('page_parameters_form_tags'),
              'allow_add': false,
              'value': page.tags.concat(),
            },
            'seo_title': {
              'type': 'text',
              'label': translator.translate('seo_title'),
              'value': page.seo.title,
            },
            'seo_description': {
              'type': 'textarea',
              'label': translator.translate('seo_description'),
              'value': page.seo.description,
              'resize': false,
              'rows': 6,
            },
            'seo_index': {
              'type': 'switch',
              'label': translator.translate('seo_index'),
              'value': Boolean(page.seo.index),
            },
            'seo_follow': {
              'type': 'switch',
              'label': translator.translate('seo_follow'),
              'value': Boolean(page.seo.follow),
            },
          };

          if (!pageCategories.length) {
            delete config.elements.category;
          }

          if (!container.get('isAllowedTo')('PUBLISH_PAGE')) {
            delete config.elements.is_online;
          }

          if (page.type_data && false === page.type_data.is_removable) {
            delete config.elements.is_online;
            delete config.elements.published_at;
          }

          if (!searchEngine) {
            delete config.elements.seo_index;
            delete config.elements.seo_follow;
          }

          mediator.publish('before:render:form-page-parameters', {
            formConfig: config,
            pageData: page,
          });

          form = FormBuilder.getForm(config);
          form.page = page;

          form.on('submit', onSubmit);
          form.on('validate', onValidate);

          $container.append(form.render());

          let $associatedPageLink = jQuery(`<a class="setting-link"" href="#">${translator.translate('manage_associated_pages')}</a>`);

          $associatedPageLink.on('click', function(e) {
            onAssociatedPageLinkClick(e, page);
          });

          $container.find('.element_page_language').append($associatedPageLink);

          if (!searchEngine) {
            $container.find('.element_seo_description').after(`<p>${translator.translate('seo_no_index_no_follow')}</p>`);
          }

          let $autocompleteInput = form.$.find('.element_tags').find('input');
          $panel.on('click', function(e) {
            let $target = jQuery(e.target);

            if (!$target.is($autocompleteInput)) {
              if ($target.hasClass('autocomplete-search')) {
                $autocompleteInput.autocomplete('search', $autocompleteInput.val());
              } else {
                $autocompleteInput.val('');
                if ($autocompleteInput.hasClass('ui-autocomplete-input')) {
                  $autocompleteInput.autocomplete('close');
                }
              }
            }
          });

          $buttons = zone.createSubmitButtons({
            onSubmitClick: form.submit.bind(form),
          });
        }

        Loader.stop($panel);

        if (page.type_data && page.type_data.is_removable && container.get('isAllowedTo')('DELETE_PAGE')) {
          let $btn = jQuery('<button class="btn btn-default btn-block btn-xs"><i class="icon icon-trash-o"></i>' + translator.translate('delete_page') + '</button>');
          pageLabel = '<p class="mt-2">' + page.title + '</p><p class="mt-2">' + page.url + '</p>';
          $btn.on(container.get('isMobile') ? 'touchstart MSPointerDown' : 'click', deleteConfirm);
          $buttons.prepend(jQuery('<div class="col-md-12"></div>').append($btn));
        }

        zone.setFooter($panel, $buttons);

        fixHeight.fix($panel.find('.cloud-panel-content'), jQuery(window).height() - 100 - $panel.find('.cloud-panel-footer').outerHeight());

        dfd.resolve();
      }).fail(function(data, response) {
        dfd.reject(data, response);
      });
    });
  });
};
